"use client";

import { useEffect } from "react";

// 우측 슬라이드 오버레이 드로어. 헤더(타이틀/부제/X) + 본문 + sticky 푸터.
export function Drawer({
  open,
  title,
  subtitle,
  onClose,
  footer,
  children,
  width = "max-w-md",
}: {
  open: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  footer?: React.ReactNode;
  children: React.ReactNode;
  width?: string;
}) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end" role="dialog" aria-modal="true">
      <button
        type="button"
        aria-label="닫기"
        className="absolute inset-0 bg-black/30"
        onClick={onClose}
      />
      <div
        className={`relative flex h-full w-full ${width} flex-col bg-surface text-left shadow-xl`}
        style={{ borderLeft: "1px solid var(--line)" }}
      >
        <div
          className="flex items-start justify-between gap-3 px-5 py-4"
          style={{ borderBottom: "1px solid var(--line)" }}
        >
          <div className="min-w-0">
            <h2 className="text-base font-bold text-ink">{title}</h2>
            {subtitle && <p className="mt-0.5 text-xs text-muted">{subtitle}</p>}
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="닫기"
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[8px] text-muted transition-colors hover:bg-surface-2"
          >
            ✕
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>

        {footer && (
          <div
            className="flex items-center justify-end gap-2 px-5 py-3.5"
            style={{ borderTop: "1px solid var(--line)" }}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
